import {
  DbFile,
  DbFileActionLog,
  DbFolder,
  DbFolderActionLog,
  DbProject,
} from '~src/types/db';
import { appLog } from '~src/utils/log';
import { apiCweb } from './api-cweb';

export interface LoadFilesActionLogParams {
  projectId: DbProject['id'];
  skip?: number;
  take?: number;
  before?: number;
  after?: number;
  response_type?: string;
}

export const loadFilesActionLog = async (
  key: string,
  {
    projectId,
    skip,
    take,
    before,
    after,
    response_type,
  }: LoadFilesActionLogParams
) => {
  appLog('loadFilesActionLog -> ', {
    projectId,
    skip,
    take,
    before,
    after,
    response_type,
  });
  const res = await apiCweb.get(
    `projects/${projectId}/action_log/versionedfile`,
    {
      params: {
        skip,
        take,
        before,
        after,
        response_type,
      },
      timeout: response_type === 'csv' ? 60000 : 10000,
    }
  );

  return { logs: res.data, totalCount: res.headers['total-count'] };
};

export interface LoadFolderPermissionLogParams {
  projectId: DbProject['id'];
  skip?: number;
  take?: number;
  before?: number;
  after?: number;
  response_type?: string;
}

export const loadFolderPermissionLog = async (
  key: string,
  {
    projectId,
    skip,
    take,
    before,
    after,
    response_type,
  }: LoadFolderPermissionLogParams
) => {
  appLog('loadSecurityGroupActionLog -> ', {
    projectId,
    skip,
    take,
    before,
    after,
    response_type,
  });
  const res = await apiCweb.get(
    `projects/${projectId}/action_log/folder_permission`,
    {
      params: {
        skip,
        take,
        before,
        after,
        response_type,
      },
      timeout: response_type === 'csv' ? 60000 : 10000,
    }
  );

  return { logs: res.data, totalCount: res.headers['total-count'] };
};

export interface LoadFileLogParam {
  projectId: DbProject['id'];
  versionedfileId: DbFile['id'];
  createdBy?: number;
  before?: number;
  skip?: number;
  take?: number;
}

export const loadFileLog = async (
  key: string,
  {
    createdBy,
    before,
    projectId,
    versionedfileId,
    skip,
    take,
  }: LoadFileLogParam
) => {
  appLog('loadFileActionLog => ', {
    createdBy,
    before,
    projectId,
    versionedfileId,
    skip,
    take,
  });
  const res = await apiCweb.get<DbFileActionLog[]>(
    `projects/${projectId}/action_log/versionedfile/${versionedfileId}`,
    { params: { before, created_by: createdBy, skip, take } }
  );
  return { logs: res.data, totalCount: res.headers['total-count'] };
};

export interface LoadFoldersParam {
  projectId: DbProject['id'];
  createdBy?: number;
  before?: number;
  after?: number;
  skip?: number;
  take?: number;
}

export const loadFoldersLog = async (
  key: string,
  { projectId, createdBy, before, after, skip, take }: LoadFoldersParam
) => {
  appLog('loadFoldersLog => ', {
    projectId,
    before,
    createdBy,
    after,
    skip,
    take,
  });
  const res = await apiCweb.get<DbFolderActionLog[]>(
    `projects/${projectId}/action_log/folder`,
    { params: { created_by: createdBy, before, after, skip, take } }
  );
  return { logs: res.data, totalCount: res.headers['total-count'] };
};

export interface LoadFolderLogParam {
  projectId: DbProject['id'];
  folderId?: DbFolder['id'];
  before?: number;
  response_type?: string;
  skip?: number;
  take?: number;
}

export const loadFolderLog = async (
  key: string,
  { before, projectId, folderId, response_type, skip, take }: LoadFolderLogParam
) => {
  appLog('loadFolderActionLog => ', {
    before,
    projectId,
    folderId,
    response_type,
    skip,
    take,
  });
  const res = await apiCweb.get<DbFolderActionLog[]>(
    `projects/${projectId}/action_log/folder/${folderId}`,
    {
      params: { before, response_type, skip, take },
      timeout: response_type === 'csv' ? 60000 : 10000,
    }
  );
  return { logs: res.data, totalCount: res.headers['total-count'] };
};
